import {
  ImageField,
  imageMobileField,
  LinkField,
  StringField,
  CardFields,
  CardProps,
  CategoryField,
  CategoryFields,
  CheckboxField,
  DropdownSelect,
} from "../../types/types";

export class CardModel {
  private readonly fields?: CardFields;
  constructor(props: CardProps) {
    this.fields = props.fields;
  }

  get all(): CardProps {
    return {
      fields: {
        Title: this.title,
        Subtitle: this.subtitle,
        Image: this.image,
        imageMobile: this.imageMobile,
        Link: this.link,
        Date: this.Date as any,
        FormatDate: this.FormatDate,
        "Card Type": this.CardType,
        Category: this.category,
        AllowFallbackForMobile: this.allowFallbackForMobile,
      },
    };
  }

  get title(): StringField {
    return this.fields?.Title ?? { value: "Lorem ipsum dolor sit" };
  }

  get subtitle(): StringField {
    return (
      this.fields?.Subtitle ?? {
        value: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin finibus ultrices arcu at efficitur.
          Curabitur vehicula elit quis semper venenatis. `,
      }
    );
  }

  get image(): ImageField {
    return (
      this.fields?.Image ?? { value: { src: "https://picsum.photos/500" } }
    );
  }

  get imageMobile(): imageMobileField {
    return (
      this.fields?.imageMobile ?? {
        value: { src: "https://picsum.photos/500" },
      }
    );
  }

  get imageSrc(): string {
    return this.fields?.Image?.value?.src ?? "https://picsum.photos/500";
  }

  get imageAlt(): string {
    return (this.fields?.Image?.value?.alt ?? '') as string;
  }

  get imageWidth(): string {
    return (this.fields?.Image?.value?.width ?? '') as string;
  }

  get imageHeight(): string {
    return (this.fields?.Image?.value?.height ?? '') as string;
  }

  get link(): LinkField {
    return this.fields?.Link ?? { value: { href: "#", text: "Click here" } };
  }

  get Date(): StringField | undefined {
    return this.fields?.Date;
  }

  get FormatDate(): StringField | undefined {
    return this.fields?.FormatDate;
  }

  get CardType(): DropdownSelect | undefined {
    return this.fields?.["Card Type"];
  }

  get category(): CategoryField | undefined {
    return this.fields?.Category;
  }

  get allowFallbackForMobile(): CheckboxField {
    return this.fields?.AllowFallbackForMobile as CheckboxField;
  }
}
